import React from 'react';
import './Tabs.css';
interface Tab {
  id: string;
  label: string;
  icon?: string;
}
interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  children: React.ReactNode;
  rightContent?: React.ReactNode;
}
const Tabs: React.FC<TabsProps> = ({ tabs, activeTab, onTabChange, children, rightContent }) => {
  return (
    <div className="tabs-container">
      <div className="tabs-header">
        <div className="tabs-header-left">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onTabChange(tab.id);
              }}
            >
              {tab.icon && <span className="tab-icon">{tab.icon}</span>}
              <span className="tab-label">{tab.label}</span>
            </button>
          ))}
        </div>
        {rightContent && (
          <div className="tabs-header-right">
            {rightContent}
          </div>
        )}
      </div>
      <div className="tabs-content">
        {children}
      </div>
    </div>
  );
};
export default Tabs;